<template>
  <div class="activity-import-issues">
    <h4 class="activity-import-issues__heading">{{ t.heading }}</h4>

    <div v-if="hasIssues" class="activity-import-issues__filters" role="tablist">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="activity-import-issues__filter"
        :class="{ 'is-active': filter === tab.key }"
        @click="filter = tab.key"
      >
        {{ tab.label }} ({{ tab.count }})
      </button>
    </div>

    <p v-if="visible.length === 0" class="activity-import-issues__empty">{{ t.none }}</p>

    <ul v-else class="activity-import-issues__list">
      <li
        v-for="(issue, index) in visible"
        :key="index"
        class="activity-import-issues__item"
        :class="`activity-import-issues__item--${issue.severity}`"
      >
        <div class="activity-import-issues__top">
          <span class="activity-import-issues__badge" aria-hidden="true">{{ issue.severity === 'error' ? '🔴' : '🟡' }}</span>
          <span class="activity-import-issues__rownum">{{ t.row }} {{ issue.row_number }}</span>
        </div>
        <p v-if="issue.activity_name" class="activity-import-issues__name">{{ issue.activity_name }}</p>
        <p class="activity-import-issues__message">{{ issue.message }}</p>
        <dl v-if="hasValues(issue)" class="activity-import-issues__values">
          <template v-for="(value, label) in issue.values">
            <dt :key="`${label}-k`">{{ label }}</dt>
            <dd :key="`${label}-v`">{{ value }}</dd>
          </template>
        </dl>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    issues: { type: String, default: '[]' },
    labels: { type: String, default: '{}' },
  },

  data() {
    return { filter: null };
  },

  created() {
    // Default to Errors when any exist, otherwise Warnings. With no issues at all
    // leave the filter unselected -- the control is hidden and only the empty
    // message shows, so no zero-count filter appears highlighted.
    if (!this.hasIssues) return;
    this.filter = this.errors.length ? 'errors' : 'warnings';
  },

  computed: {
    all() {
      return this.safeParse(this.issues, []);
    },

    t() {
      return this.safeParse(this.labels, {});
    },

    errors() {
      return this.all.filter((issue) => issue.severity === 'error');
    },

    warnings() {
      return this.all.filter((issue) => issue.severity === 'warning');
    },

    hasIssues() {
      return this.all.length > 0;
    },

    tabs() {
      return [
        { key: 'errors', label: this.t.errors, count: this.errors.length },
        { key: 'warnings', label: this.t.warnings, count: this.warnings.length },
        { key: 'all', label: this.t.all, count: this.all.length },
      ];
    },

    visible() {
      if (this.filter === 'errors') return this.errors;
      if (this.filter === 'warnings') return this.warnings;
      return this.all;
    },
  },

  methods: {
    safeParse(value, fallback) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return fallback;
      }
    },

    hasValues(issue) {
      return issue.values && Object.keys(issue.values).length > 0;
    },
  },
};
</script>
